/* esm.sh - @use-gesture/core@10.3.1/utils */
export * from "/*@use-gesture/core@10.3.1/esnext/utils.mjs";
